import { createActions } from 'redux-actions';

export const {
  getCompanyInfo,
  getCompanyInfoSuccess,
  getCompanyInfoFailure,
  updateCompanyInfo,
  updateCompanyInfoSuccess,
  updateCompanyInfoFailure,
} = createActions(
  'GET_COMPANY_INFO',
  'GET_COMPANY_INFO_SUCCESS',
  'GET_COMPANY_INFO_FAILURE',
  'UPDATE_COMPANY_INFO',
  'UPDATE_COMPANY_INFO_SUCCESS',
  'UPDATE_COMPANY_INFO_FAILURE',
);
